import { Pipe, PipeTransform } from '@angular/core';
import { map as _map, keys as _keys, filter as _filter, includes as _includes, isUndefined as _isUndefined,
isNull as _isNull, isEmpty as _isEmpty, cloneDeep as _cloneDeep, lowerCase as _toLowerCase} from 'lodash-es';

@Pipe({
  name: 'filterSelectedTable',
  pure: false
})
export class FilterSelectedTablePipe implements PipeTransform {

  transform(object, model: any[], searchString: string, tableCategoryVisibilityStrategy: Set<any>): any[] {

    const selectedTableKeys = _map(model, 'name');
    let filteredObject = _cloneDeep(object);
    tableCategoryVisibilityStrategy.clear();
    if (!_isUndefined(searchString) && !_isEmpty(searchString)) {
      const searchStringLower = _toLowerCase(searchString);
      filteredObject = _filter(object, (table) => {
        return _includes(_toLowerCase(table.name), searchStringLower);
      });
    }

    return _filter(filteredObject, (table) => {
      return !_includes(selectedTableKeys, table.name);
    });
  }

}
